import Vue from 'vue'

const client = Vue.prototype.$api

export default {
  getProfSubspecialities ({name, specialtyId, hideLoadingIcon}) {
    return client.get('subspecialties/getProfSubspecialitiesBySpecialty', { params: {name: name, specialtyId: specialtyId}, loading: !hideLoadingIcon })
  },
  getCenterSubspecialities ({name, specialtyId, hideLoadingIcon}) {
    return client.get('subspecialties/getCenterSubspecialitiesBySpecialty', { params: {name: name, specialtyId: specialtyId}, loading: !hideLoadingIcon })
  }
}


// WEBPACK FOOTER //
// ./src/repositories/SubspecialitiesRepository.js